import * as types from "../../actions/ActionTypes";

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const updateJobReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.UPDATE_JOB_START:
            return { ...state, loading: true, error: null };

        case types.UPDATE_JOB_SUCCESS:
            return { ...state, loading: false, data: action.payload, error: null };

        case types.UPDATE_JOB_ERROR:
            return { ...state, loading: false, error: action.payload };

        case types.UPDATE_JOB_RESET:
            return initialState;

        default:
            return state;
    }
};

export default updateJobReducer;
